module.exports = __webpack_public_path__ + "static/media/S3N3-5.a26511c3.svg";